module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_5010.7996abd9.png";